module.exports = __webpack_public_path__ + "static/img/dadi2026Banner2.b52d3b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/dadi2026Banner2.png
// module id = Fr3B
// module chunks = 4